import { INSTANT_PRODUCT_TYPE } from '~/helpers/offers'
import type { ProductTypeName } from '~/types/offer'

// A breach voucher only tells us the asset group and whether the breached product was an
// instant one, so the redirect can restore the asset tab and the prime/instant variant.
// Without an explicit `program` the challenges layout falls back to prime, which is why
// the futures branch has to spell it out too.
export const buildVoucherRedirectUrl = (voucherCode: string, assetGroup?: string, productType?: ProductTypeName) => {
  const asset = assetGroup === 'FUTURES' ? 'futures' : 'cfd'
  const program = productType === INSTANT_PRODUCT_TYPE ? 'instant' : 'prime'

  return `/challenges/${asset}?program=${program}&vchr=${voucherCode}`
}

export const handleVoucherRedirect = async (voucherCode: string, navigate: (path: string) => void) => {
  try {
    const response = await fetch(`/api/vouchers/${voucherCode}/compatibilities`)
    const { assetGroup, productType } = await response.json()

    navigate(buildVoucherRedirectUrl(voucherCode, assetGroup, productType))
  } catch (error) {
    console.error('Error fetching voucher compatibilities:', error)
    navigate(buildVoucherRedirectUrl(voucherCode))
  }
}
